// extracted by mini-css-extract-plugin
export default {"terms":"Terms_terms__zKIa8","container":"Terms_container__uDIgy","title":"Terms_title__+uyTW","subtitle":"Terms_subtitle__OL58K","text":"Terms_text__gDepq"};